import { observer } from 'mobx-react';
import React, { Component } from 'react';
import FuseCheckbox from './FuseCheckbox';
import FuseReadOnlyComponent from './FuseReadOnlyComponent';

/**
 * This is a fuse radio button with the ReadOnly property changed to render what we need it to, according to
 * the new policy specs. See FuseReadOnlyComponent for a better description of the reason we do this.
 * */
class FuseReadOnlyCheckbox extends Component {
    static propTypes = {
        ...FuseReadOnlyComponent.PropType,
        ...FuseCheckbox.PropType,
    };

    render = () => {
        return <FuseReadOnlyComponent
            component={FuseCheckbox}
            readOnlyValue={this.props.label}
            {...this.props}
        />;
    }
}

export default observer(FuseReadOnlyCheckbox);
